import axios from "axios";

// Define the type for formValues
interface FormValues {
  DTSVersion?: string;
  MSDCompound?: string;
  msd_type?: string;
  supplierCompound?: string;
  supplierOrganization?: string;
  transferId?: string;
  requesters?: any; // Replace 'any' with the appropriate type
  suppliers?: any; // Replace 'any' with the appropriate type
  file_name?: string;
  record_id?: string;
  upload_dts?: any;
  created_by?: string;
  updated_by?: string;
  environment?: string;
  init_deliverables?: any;
  protocol_number?: string;
  status?: string;
  description_change?: string;
  is_offline_flow?: boolean;
  // purpose?: string
}

// Define a type for the response data
interface SaveDraftResponseData {
  record_id?: string;
  // Add other fields that you expect in the response
}

// Define the return type of the function
type SaveDraftResponse = {
  data?: SaveDraftResponseData;
  message?: string;
} | null;

export const SaveDraft = async (
  formValues: FormValues | undefined,
): Promise<SaveDraftResponse> => {
  try {
    const apiUrl = `${process.env.REACT_APP_PROXY_URL}/v1/saveDetails`;
    const response = await axios.post(apiUrl, formValues, {
      headers: {
        "Content-Type": "application/json",
        Authorization: "Basic " + process.env.REACT_APP_AUTHORIZATION_KEY,
        "x-merck-apikey": process.env.REACT_APP_X_MERCK_API_KEY,
      },
    });
    return response; // Return the response if successful
  } catch (err: any) {
    if (err.response) {
      throw new Error(err.response.data.message);
    } else {
      throw new Error("An unexpected error occurred");
    }
  }
};
